import { AppData, Colors, Lightning, Log } from '@lightningjs/sdk'
import { SelectScreenInfo, SelectScreenOptionInfo } from '../lib/app-api-config'
import { AppSetup } from '../lib/app-setup'
import { Row } from '@lightningjs/ui-components'
import SelectScreenTile from '../lib/components/grid/SelectScreenTile/SelectScreenTile'
import Router from '@lightningjs/sdk/src/Router'
import { KeyCodes } from '../lib/key-codes'
import TwoRowThumb from '../lib/components/grid/TwoRowScreenTile/TwoRowThumb'
import TwoRowThumb2 from '../lib/components/grid/TwoRowScreenTile/TwoRowThumb2'
import { Logger } from '../lib/logger'

export interface SelectScreenTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Background: object
    Title: object
    SelectList: Row

}

export interface SelectScreenTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true
}

export default class SelectScreen
    extends Lightning.Component<SelectScreenTemplateSpec, SelectScreenTypeConfig>
    implements Lightning.Component<SelectScreenTemplateSpec>
{
    Title = this.getByRef('Title')!
    SelectList = this.getByRef('SelectList')!
    Skip = this.getByRef('Skip')!
    selectScreenInfo: SelectScreenInfo | undefined
    isLiveL1Available = false;

    interteractionTimeout = 3;
    interteractionTimer = null;

    liveTimeout = 15;
    liveTimer = null;
    liveTvThumb = null;

    static override _template(): Lightning.Component.Template<SelectScreenTemplateSpec> {
        // const { appState } = AppData as AppSetup
        // const selectScreenObject: SelectScreenInfo | undefined =
        //   appState?.getAppApiConfig()?.appConfig?.selectscreen
        // Log.info('SelectScreen:', selectScreenObject)
        return {
            ...super._template(),
            w: 1920,
            h: 1080,
            rect: true,
            color: 0xff222222,
            collision:true,
            flex: { alignItems : 'center', justifyContent: 'center'},
            Background: {
                flexItem: false,
                w: 1920,
                h: 1080,
                src: '',
            },
            HeaderImageWrapper: {
                flexItem: false,
                w: 1920,
                h: 150,
                zIndex: 1,
                HeaderImage: {
                    x: (w) => w / 2 + 50,
                    y: (h) => h / 2,
                    mountX: 0.5,
                    mountY: 0.5,
                    src: '',
                },
            },
            SelectList: {
                type: Row,
                collision: true,
                autoResizeWidth: true,
                autoResizeHeight: true,
                signals: {'selectedChange': '$selectedItemChange'}
            },
            Skip: {
                flexItem: false,
                x: (w) => w / 2,
                y: 1020,
                w: 414,
                h: 72,
                mountX: 0.5,
                mountY: 1,
                zIndex: 10,
                collision: true,
                type: TwoRowThumb2,
                rowIndex: 2
            },
            AutoLiveTimer: {
                flexItem: false,
                x: 1900,
                y: 50,
                mountX: 1,
                flex: { margin: 0 },
                Label: {
                    text: { text: 'Launching live in ', fontsize: 40, textColor: 0xffffffff }
                },
                CountDown: {
                    text: { text: '15 seconds!', fontsize: 40, textColor: 0xffffffff }
                },
                visible: false
            }
        }
    }

    override _setup() {
        const { appState } = AppData as AppSetup
        const appConfig = appState?.getAppApiConfig()?.appConfig;
        this.selectScreenInfo = appConfig?.selectscreen
        Log.info('SelectScreenInfo:', this.selectScreenInfo, appConfig)
        const items: any = []
        const liveOptUrl = (!this.selectScreenInfo.liveTvFeedUrl || this.selectScreenInfo.liveTvFeedUrl == '') ? null : this.selectScreenInfo.liveTvFeedUrl;
        this.isLiveL1Available = (liveOptUrl) ? true : false;
        let indx = 0
        if (this.isLiveL1Available) {
            items.push({
                w: parseInt(this.selectScreenInfo?.optimgw),
                h: parseInt(this.selectScreenInfo?.optimgh),
                type: TwoRowThumb,
                imgSrc: this.selectScreenInfo.liveTvImg,
                selectedImgSrc: item.imgSelect,
                rowIndex : 0,
                itemIndex: indx,
                title: '',
                blockItem: false,
                itemType: 'live',
                index: indx++
                // .contain(
                //   parseInt(selectScreenInfo?.optimgw),
                //   parseInt(selectScreenInfo?.optimgh),
                // ),
            })
            this.startInteractionTimeout();
        }
        this.selectScreenInfo?.options.map((item) => {
            items.push({
                w: parseInt(this.selectScreenInfo?.optimgw),
                h: parseInt(this.selectScreenInfo?.optimgh),
                type: TwoRowThumb,
                imgSrc: item.img,
                selectedImgSrc: item.imgSelect,
                rowIndex: 0,
                title: '',
                itemIndex: indx,
                blockItem: item.blockItem,
                collision: true,
                itemType: 'l1',
                index: indx
                // .contain(
                //   parseInt(selectScreenInfo?.optimgw),
                //   parseInt(selectScreenInfo?.optimgh),
                // ),
            })
            indx++
        })
        this.tag('Background').src = this.selectScreenInfo?.bgImg
        this.tag('HeaderImageWrapper.HeaderImage').src = appConfig?.header_logo
        this.tag('Skip').imgSrc = this.selectScreenInfo?.skipimg
        this.tag('Skip').selectedImgSrc = this.selectScreenInfo?.skipimgSelect
        if (this.selectScreenInfo?.options.length > 4) {
            this.tag('SelectList')?.patch({
                autoResizeWidth: false,
                scrollIndex: 2,
                w: 1920
            })
        }
        this.tag('SelectList').items = items
    }

    $selectedItemChange(selected) {
        if(this.isLiveL1Available) {
            this.startInteractionTimeout()
        }
    }

    override _getFocused():
        | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
        | null
        | undefined {
        return this.tag('SelectList')
    }

    override _detach(): void {
        this.stopInteractionTimeout()
        this.stopLiveTimer()
    }

    override _handleBack() {
        Router.navigate('main-grid-screen/' + 0, false)
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        if(e.keyCode == KeyCodes.KEY_EXIT) {
            const { appState } = AppData as AppSetup
            const app = appState?.getApp()
            app?.handleAppExit()
            return true
        }
    }

    override _handleDown() {
        Log.info("handledown selectlist");
        this._setState('Skip')
        return true
    }

    override _handleEnter() {
        const index = this.tag('SelectList').selectedIndex
        const otherItem = this.tag('SelectList').selected
        const item: SelectScreenOptionInfo = this.selectScreenInfo?.options[index]
        if(item.l1_mapping == null || item.l1_mapping=='') {
            item.l1_mapping = 0
        }
        if(item.blockItem) {
            this.widgets.notification.showMessage('')
            return
        }
        //app?.loadL1(item.l1_mapping)
        if(otherItem.itemType == 'live') {
            this.stopInteractionTimeout()
            this.loadAndPlayLiveFromSelectScreen()
            //Router.navigate('main-grid-screen/' + item.l1_mapping, false)

        } else {
            Logger.processUserAction('selectedAnOptionFromSelectScreen', item.title)
            Router.navigate('main-grid-screen/' + item.l1_mapping, false)
        }
    }

    async loadAndPlayLiveFromSelectScreen() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()!
        const url = this.selectScreenInfo?.liveTvFeedUrl
        const grid = app.loadLiveTvfromSelectScreen(url)
        app.navigation.push(grid)
        await grid.fetchInitialRows()
        const vodInfo = grid.getFocusedItem()
        Router.navigate('video-screen-live/' + vodInfo.node_id, false)
    }

    showLiveTimer = (time) => {
        this.tag('CountDown').text.text = time + ' seconds!'
        this.tag('AutoLiveTimer').visible = true
    }

    hideLiveTimer = () => {
        this.tag('CountDown').text.text = '0 seconds!'
        this.tag('AutoLiveTimer').visible = false
    }

    startLiveTimer() {
        let cnt = 0;
        this.showLiveTimer(this.liveTimeout - cnt);
        this.liveTimer = setInterval(() => {
            cnt++;
            this.showLiveTimer(this.liveTimeout - cnt);
            if (this.liveTimeout - cnt <= 0) {
                this.stopInteractionTimeout()
                this.loadAndPlayLiveFromSelectScreen()
                //this._handleEnter()
                //this.close(this.selectscreenObj.options[indx].type);
            }
        }, 1000);

    }

    stopLiveTimer() {
        clearInterval(this.liveTimer);
        this.hideLiveTimer();
    }

    startInteractionTimeout = () => {
        this.stopInteractionTimeout();
        this.interteractionTimer = setTimeout(() => {
            this.startLiveTimer();
        }, this.interteractionTimeout * 1000);
    }

    stopInteractionTimeout = () => {
        clearTimeout(this.interteractionTimer);
        this.stopLiveTimer();
    }
    // override _handleRight() {
    //   Log.info('_handleRight')
    //   //this.tag('SelectList').moveRight()
    // }

    $handleThumbClick(target) {
        Log.info('SelectScreen $handleThumbClick:', target)
        this.tag('SelectList').selectedIndex = target.index
        this._handleEnter()
    }

    $handleHover(target) {
        Log.info('SelectScreen $handleHover:', target)
    }

    static override _states() {
        return [
            class SelectList extends this{
                override _getFocused() {
                    Log.info('SelectList: SelectList _focus: ')
                    return this.tag('SelectList')!
                }
            },
            class Skip extends this{
                override _getFocused() {
                    Log.info('SkipButton: SkipButton _focus: ', this.tag('Skip'))
                    const { platform } = AppData as AppSetup;
                    platform?.textToSpeach('Skip')

                    return this.tag('Skip') || null
                }
                override _handleUp() {
                    Log.info("handleup button");
                    this._setState('SelectList')
                    return true
                }
                override _handleEnter() {
                    Logger.processUserAction('skippedSelectionFromSelectScreen')
                    Router.navigate('main-grid-screen/' + 0, false)
                }
            }
        ];
    }
}
